export default function ModalPopupComponent(props) {
  let styles = props ? props?.modalCss : { modal_container: "" };

console.log('ModalPopup', props);  
  


   // Directly toggle scroll lock if popup is open/closed and as per this condition we are avoiding the scroll on body when popup is open

  if (typeof window !== "undefined") {
    if (props.isPopup) {
      document.body.classList.add("no-scroll");
      document.documentElement.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
      document.documentElement.classList.remove("no-scroll");
    }
  }

  
  return (
    <>
      {props.isPopup === true ? (
        <>
          <div
            className={`${styles.modal_background || ''}  modal-background`}
            onClick={() => {
              if (props.outSideClickBool) {
                props.onOutSideClick(false);
              }
            }}
          ></div>
          <div className={`${styles.modal_container} modal-container`}>

            <div className={`${styles.modal_content} modal-content`}>

              {props.showBackButton === false ? null : (
                <div
                  onClick={props.onBackPopup}
                  className={`${styles.modal_back} modal-back`}
                >
                  {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#000000"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg> */}
                  <img src="/images/back-left-arrow.svg" alt="back" className={styles.close_icon} />
                </div>
              )}

              {props.showCrossButton === false ? null : (
                <div
                  onClick={props.onClosePopup}
                  className={`${styles.modal_close} modal-close`}
                >
                  {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#000000"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg> */}
                  <img src="/images/cross_black.svg" alt="Close" className={styles.close_icon} />
                </div>
              )}
              {props.children}
            </div>
          </div>

        </>
      ) : null}
    </>
  );
}
